import { render, staticRenderFns } from "./BasketButton.vue?vue&type=template&id=65dde9af"
import script from "./BasketButton.vue?vue&type=script&lang=js"
export * from "./BasketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports